/**
 * CalculatorCard — мобильная карточка-калькулятор: степпер числа врачей,
 * пояснение по пакету и итог/мес. Живой расчёт по активным пакетам.
 */

import {useState} from 'react';

import {clinicQuoteFor} from '@services/clients';
import type {ClinicTariff} from '@services/tariffs';
import {formatNumber} from '@utils/format';

import {CalcIcon} from '../../CalcIcon';
import {SeatStepper} from '../../SeatStepper';
import {explainQuote} from '../../Tariffs.utils';

type CalculatorCardProps = {clinic: ClinicTariff};

export const CalculatorCard = ({clinic}: CalculatorCardProps) => {
  const [seats, setSeats] = useState(6);
  const quote = clinicQuoteFor(seats, clinic.packages, clinic.overPrice);

  return (
    <div className="rounded-[15px] border border-skr-info-border bg-skr-info px-[17px] py-4">
      <div className="flex items-center gap-2 text-[13.5px] font-semibold text-skr-info-ink">
        <CalcIcon size={17} />
        Калькулятор
      </div>
      <div className="mt-3.5 flex items-center justify-between">
        <span className="text-[13px] text-skr-info-ink2">Сколько врачей</span>
        <SeatStepper seats={seats} setSeats={setSeats} size="lg" />
      </div>
      <div className="mt-3.5 border-t border-skr-info-border pt-[13px] text-[12.5px] leading-[1.4] text-skr-info-ink2">
        {explainQuote(seats, clinic.packages, clinic.overPrice)}
      </div>
      <div className="mt-[11px] flex items-baseline justify-between border-t border-skr-info-border pt-[11px]">
        <span className="text-[13px] text-skr-info-ink2">Итого в месяц</span>
        <span>
          <span className="font-mono text-2xl font-semibold text-skr-info-ink">
            {formatNumber(quote.sum)}
          </span>{' '}
          <span className="text-xs text-skr-info-faint">сом</span>
        </span>
      </div>
    </div>
  );
};
